function CCTProductsInfini(limit_per_page,page_param,
                           withRestaurants = false ,
                           handle="",template="card_products", 
                           type_list ="",notsession = false, link_filters= [], count_filters={}) {

    let host_url = `${window.aifredUrl}/v1.0.0/aifred/marketplace/restaurants/`

    //special debug
    this.debugAiFredConnect = host_url.includes("ngrok")

    this.collection_url = host_url + "filters";
    this.url_hash_filter =  host_url +"hashfilters";
    this.url_count_filter =  host_url +"countfilters";
    this.url_link_filter =  host_url +"linkfilters";
    //this.url_count_filter = "";
    this.link_filters = link_filters;
    this.count_filters = count_filters;
    //console.log("CCTProductsInfini first_load",{link_filters})
    this.type_list = type_list;
   // this.notsession = notsession || false;
    this.notsession = true;
    this.handle = handle;
    this.template = template;
    this.withRestaurants= withRestaurants
    this.urlBase = window.location.pathname.split("?")[0] || ''

    this.params_filter={
        "page":"page=1",
        "page_param":"page_param="+page_param,
        "urlbase":"urlbase="+ this.urlBase,
        "limit":"limit="+limit_per_page
    }

     if(sessionStorage.getItem("filter_prod")){
        let paramsSessionStorage = JSON.parse(sessionStorage.getItem("filter_prod"))
        if(!!paramsSessionStorage[this.urlBase] && Object.values(paramsSessionStorage[this.urlBase]).length > 0){
          //  console.log({localcurrent:paramsSessionStorage[this.handle]})
            this.params_filter = paramsSessionStorage[this.urlBase]
        }
     }
    if(!!handle){
        this.params_filter['handle']="handle=" + handle
    }
    console.log("CCTProductsInfini params_filter",{params_filter:this.params_filter})
    this.init();
}

CCTProductsInfini.prototype = {
    _:{
        selectors:{
        },
        messages: { }
    },
    emit:function(name){
        var colorBG = "#1e98ec"
        if(name==="productUnvalid"){
            colorBG = "red"
        }
        if(name==="productValid"){
            colorBG = "green"
        }
        console.log("%c→ EMIT CCTProductsInfini." + name,"background:"+colorBG+";color:#FFF")
        console.log({arguments})
        $(document).trigger('CCTProductsInfini.'+name,arguments);
    },
    changeSelectVariants(evt, name, data){
        evt.preventDefault();
        evt.stopPropagation();
        const selectElement = evt.currentTarget;
        //  const selectedValue = selectElement.value;
        const selectedIndex = selectElement.selectedIndex;
        const options = selectElement.options;
        const selectedOption = options[selectedIndex];
        let dataPrice = selectedOption.dataset.price;
        let pid = selectedOption.dataset.pid;
        let vid = selectedOption.dataset.vid;
        dataPrice =  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(parseInt(dataPrice)/100)
        //  console.log({dataPrice,pid,vid})
        $('.js-product_card[data-pid='+pid+'] .js-product_price').html(dataPrice)
        $('.js-product_card[data-pid='+pid+'] .js-add_product').attr("data-variant",vid)
        //.html(vid) //.dataset.vid = vid
    },
    delay: async function(ms){
        return new Promise(resolve => setTimeout(resolve, ms))
    },
    addproductCart: async function(evt, name, data) {
        evt.preventDefault();
        evt.stopPropagation();
        const buttonElement = evt.currentTarget;
        buttonElement.setAttribute("disabled", true)
        buttonElement.style.opacity = 0.6
        const vid = buttonElement.dataset.variant.replace("gid://shopify/ProductVariant/","");

        let productCart = TT.getProduct(vid)
        let qty = 0;
        if (!!productCart) {
            qty = parseInt(productCart.quantity);
        }
        const vendor = buttonElement.dataset.vendor;

        //let vid =  $(selectElement).parent().find("select")
        let datas = {
            variant_id: vid,
            quantity: qty + 1,
            vendor: vendor,
            properties: {
                _originQuantity: qty,
                _vendor: vendor
            }
        };
        //  console.log(datas)

        let quantity = parseInt(TT.getQuantityForChange(datas))
        //    console.log(qty, quantity, vendor, vid)

        this.emit('changeProductQuantity', datas);

        if (TT.getCountProducts() === 0) {
            await this.delay(2000)
        }

        buttonElement.removeAttribute("disabled")
        buttonElement.style.opacity = 1
        if (qty > 0) {
            $(".js-drawer-open-cart").click()
        }
    },
    toggleBodyScroll: function(disable) {
        document.body.style.overflow = disable ? 'hidden' : '';
        console.log("toggleBodyScroll", disable)
    },
    openFilterMobile: function(evt, name, data){
        $(".js-section_aside").addClass("active")
    },
    closeFilterMobile: function(evt, name, data){
        $(".js-section_aside").removeClass("active")
    },
    displayOtherProducts:function (evt, name, data){
        $(".js-button-more").addClass("hidden");
        $(".js-restaurant_paginate").removeClass("hidden");
        $(".js-product_card ").removeClass("hidden");
    },
    getCollection:async function(){
        if(this.collection_url ===""){
            return false
        }
        let params = ""
        if( Object.values(this.params_filter).length > 0){
            params = "?"+ Object.values(this.params_filter).join("&")
        }

        let url = this.collection_url+params
        //console.log("ajax getCollection",{url})
        let options= {
            headers:{
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-TIPTOQUE-AUTH-TOKEN":"3dfcb3274eb1f918a76cd97aee2a9e8b"
            },
            method: 'GET'}

        if(this.debugAiFredConnect){
            options.headers["ngrok-skip-browser-warning"] = true
        }

        this.collection =  await fetch(url , options)
            .then(response => response.json())
        return this.collection
    },
    getCountFilters:async function(){
        if(this.url_count_filter ===""){
            return false
        }
        let params = ""
        if( Object.values(this.params_filter).length > 0){
            params = "?"+ Object.values(this.params_filter).join("&")
        }
        let url = this.url_count_filter+params

        // console.log("ajax getCountFilters",{url})
         let options= {
            headers:{
                //  "ngrok-skip-browser-warning":true,
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-TIPTOQUE-AUTH-TOKEN":"3dfcb3274eb1f918a76cd97aee2a9e8b"
            },
            method: 'GET'}

        if(this.debugAiFredConnect){
            options.headers["ngrok-skip-browser-warning"] = true
        }
        return  await fetch(url , options)
            .then(response => response.json())

    },
    getLinkFilters:async function(){
        if(this.url_link_filter ===""){
            return false
        }
        let params = ""
        if( Object.values(this.params_filter).length > 0){
            params = "?"+ Object.values(this.params_filter).join("&")
        }
        let url = this.url_link_filter+params
        //console.log("ajax getLinkFilters",{url})
        let options= {
            headers:{
                //  "ngrok-skip-browser-warning":true,
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-TIPTOQUE-AUTH-TOKEN":"3dfcb3274eb1f918a76cd97aee2a9e8b"
            },
            method: 'GET'}

        if(this.debugAiFredConnect){
            options.headers["ngrok-skip-browser-warning"] = true
        }
        //console.log({url , options})
        return  await fetch(url , options)
            .then(response => response.json())
    },
    getHashFilters:async function(){
        let params = ""
        if( Object.values(this.params_filter).length > 0){
            params = "?"+ Object.values(this.params_filter).join("&")
        }
        //let url = this.url_count_filter+'/hash'+params
        let url = this.url_hash_filter + params
        // console.log("ajax getHashFilters",{url})
        let options= {
            headers:{
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-TIPTOQUE-AUTH-TOKEN":"3dfcb3274eb1f918a76cd97aee2a9e8b"
            },
            method: 'GET'}

        if(this.debugAiFredConnect){
            options.headers["ngrok-skip-browser-warning"] = true
        }

        return await fetch(url , options)
            .then(response => response.json())

    },
    getHash:async function(key_filter){
        return this.jsonhash?.filters?.[key_filter] || null;
    },
    renderFilterLink:async function(first_load=false){
        let jsonFiltersLinks = await this.getHash('jsonFiltersLinks')
        //console.log("link_filters",this.link_filters)
        this.first_load_link = (!!this.link_filters && this.link_filters.hash_key == jsonFiltersLinks.hash_key && first_load)
        let link_filters = {};
        console.log("first_load_link",{
            hash_key_shopify: this.link_filters?.hash_key || 'no',
            hash_key_aifred: jsonFiltersLinks?.hash_key || 'no',
            is_link_filters: !!this.link_filters,
            first_load: first_load
        })
        if (this.first_load_link) {
            link_filters = this.link_filters
            console.log("first_load pas de render link")
            return true
        } else {
            link_filters = await this.getLinkFilters()
        }

        //console.log("nyk",{first_load,links})
        /*
        if(this.link_filters['link_filters'].length === 0){
            console.log("No link filters found, skipping link rendering.")
            links = await this.getLinkFilters();
        }
        */
        //initialiser les lien et les checkbox data link en label et pas de link
        
        $(`.js-filter_tag`).removeAttr("data-link")
        $(`.js-filter_label`).each(function() {
            const $el = $(this);
            const content = $el.html();
            const attrs = {};
            $.each(this.attributes, function() {
                if(this.name !== 'href') {
                    attrs[this.name] = this.value;
                }
            });
            let attrString = '';
            for (let key in attrs) {
                attrString += ` ${key}="${attrs[key]}"`;
            }
            const $label = $(`<label${attrString}>${content}</label>`);
            $el.replaceWith($label);
        });

        //console.log({link_filters})
         for (let link of link_filters.links) {
           let element_label = $(`.js-filter_label[data-tag="${link.tag}"]`)
           let element_checkbox = $(`.js-filter_tag[data-tag="${link.tag}"]`)
           let content_label = element_label.html()
            if (element_label.length) {
                // Récupérer tous les anciens attributs sauf href
                const attrs = {};
                $.each(element_label[0].attributes, function() {
                    if (this.name !== 'href') {
                        attrs[this.name] = this.value;
                    }
                });
                // Ajouter href
                attrs['href'] = link.url;
                // Générer la chaîne d'attributs
                let attrString = '';
                for (let key in attrs) {
                    attrString += ` ${key}="${attrs[key]}"`;
                }
                // Remplacer par un <a> avec les anciens attributs + href
                element_label.replaceWith(
                    `<a${attrString}>${content_label}</a>`
                );
                element_checkbox.attr("data-link", `${link.url}`);
            }
        }

    },
    //-- afficher le nombre de produit en fonction de la collection
    renderFilterCount:async function(){
        //verifier le hash si il est identique par rapport a la page first
        let jsonFiltersCount = await this.getHash('jsonFiltersCount')
        this.first_load_count = (!!this.count_filters && this.count_filters.hash_key == jsonFiltersCount.hash_key)
        let filters ={};
        // console.log("first_load_count",{
        //     count_filters:this.count_filters || 'no',
        //     hash_key_shopify:this.count_filters.hash_key || 'no',
        //     hash_key_aifred:jsonFiltersCount.hash_key || 'no',
        //     is_count_filters:!!this.count_filters
        // })   
        
        if (
            !this.count_filters ||
            (Array.isArray(this.count_filters) && this.count_filters.length === 0) ||
            (Object.keys(this.count_filters).length === 0)
        ) {
            $('.filter_details').removeClass("hidden")
            $('.filter_checkbox').removeClass("hidden")
        }
        
        if(this.first_load_count && this.count_filters !== null){
            filters =this.count_filters
        }else{
            filters = await this.getCountFilters()
            this.count_filters = filters
        }
        
        for (let tag in filters.totals) {
            let typeTag = tag.split("|")[0]
            let filterTag = tag.split("|")[1]
            let paramsFiltersCurrent = filters.params.filters_current[typeTag] || []
            //  console.log({tag, typeTag, filters.params.filters_current[typeTag]})
            if(filters.type_totals[typeTag] === 0 &&  !paramsFiltersCurrent.length){
                // Si le total est 0, on cache le filtre
                if( !filters.params.filters_current[typeTag] && !paramsFiltersCurrent.includes(filterTag) ){
                    $('.filter_checkbox[data-tag="'+tag+'"]').addClass("hidden")
                }
            }else{
                $('.filter_details[data-handle="'+tag+'"]').removeClass("hidden")
                let count_resto = filters.totals[tag].count_restaurants
                let element_count = $('.js-filter_count[data-tag="'+tag+'"]')
                let filter_checkbox = $('.filter_checkbox[data-tag="'+tag+'"]')
           
                if(count_resto === 0 &&  !paramsFiltersCurrent.includes(filterTag)){
                    filter_checkbox.addClass("hidden")
                }else{
                    filter_checkbox.removeClass("hidden")
                    if(element_count.length){
                    element_count.html("("+count_resto+")")
                    }
                }
            }
        }
        
        return true
    },

    saveParamsSessionStorage(url_page, datas){
        if(!this.notsession){
            //save mes nouveau filtre dans le localstorage pour le trie
            let paramsSessionStorage = JSON.parse(sessionStorage.getItem("filter_prod")) || {}
            paramsSessionStorage[url_page]=datas
            sessionStorage.setItem("filter_prod", JSON.stringify(paramsSessionStorage))
        }
    },
    // change le filtre ou le trie
    selectSortBy:async function(evt, name, data){
        //  this.params_filter["page"]="page=1"
        let sortElement = evt.currentTarget
        let sortBy = sortElement.value
        if(!this.params_filter['sort_by']){
            this.params_filter['sort_by']=[]
        }
        this.params_filter['sort_by']="sort_by=" + sortBy

        this.saveParamsSessionStorage(this.urlBase,this.params_filter)

        if(sortBy === "" && !!this.params_filter['sort_by']){
            delete this.params_filter['sort_by']
            $(".js-button-sort").each(function() {
                this.selectedIndex = 0;
            });
        }
        //  console.log({params_filter:this.params_filter})
        await this.renderProductWithFilterSort()
    },

    checkboxFilterTags:async function(evt, name, data){
        console.log("checkboxFilterTags")
        if(!!evt){
            let element_checkbox = evt.currentTarget        
            if(!!element_checkbox.getAttribute("data-link")){
                evt.preventDefault(); // Empêche le vrai changement d'état du checkbox
                window.location.href = element_checkbox.getAttribute("data-link"); // Change l'URL ici
                return true
            }
        }
        
        if(!!evt){
            $('html,body').scrollTop($('.js-section_restaurants').offset().top - 200);
        }
        
        this.params_filter['page']="page=1"
        //this.params_filter["page"]=this.params_filter["page"] || "page=1"
        let filters=[]
        let paramsTags=[]

        // --- Amélioration : ne plus désactiver tous les checkboxes (trop lent)
        // Désactiver seulement l'élément cliqué brièvement et ajouter un feedback visuel
        let clickedEl = evt ? evt.currentTarget : null;
        if (clickedEl) {
            try {
                clickedEl.disabled = true;
                $(clickedEl).closest('label, .filter_checkbox').addClass('is-loading');
            } catch(e){ /* silent */ }
            // réactiver après court délai (UX responsive) — le fetch continue en arrière-plan
            setTimeout(() => {
                try {
                    clickedEl.disabled = false;
                    $(clickedEl).closest('label, .filter_checkbox').removeClass('is-loading');
                } catch(e){ /* silent */ }
            }, 700);
        }

        // Construire les params immédiatement (pour feedback rapide)
        $(".js-filter_tag").each((index,el)=>{
            if(el.checked){
                paramsTags.push(el.dataset.tag)
                filters.push({tag : el.dataset.tag,checked:el.checked})
            }
        })

        if(!this.params_filter['filter.p.tag']){
            this.params_filter['filter.p.tag']=[]
        }
        //TODO a voir si on peu le gerrer autrement coté serveur
        if(this.handle==='privatisation-city-paris'){
            paramsTags.push("CITY|CITY_PARIS_75003")
        }
        if(paramsTags.length > 0){
            this.params_filter['filter.p.tag']="filter.p.tag=" + paramsTags.join(',')
        }

        // supprimer tous les filtres si y a pas de tags selectionner
        if(!!evt){
            if(!!this.params_filter['filter.p.tag'] && paramsTags.length === 0){
                delete this.params_filter['filter.p.tag']
                if(!!this.params_filter['sort_by']){
                    delete this.params_filter['sort_by']
                    $(".js-button-sort").each(function() {
                        this.selectedIndex = 0;
                    });
                }
            }
        }
        // console.log("nky 1",{params_filter:this.params_filter})
        //save mes nouveau filtre dans le localstorage pour les tags
        this.saveParamsSessionStorage(this.urlBase,this.params_filter)

        // Laisser le navigateur peindre le changement d'état du checkbox avant de lancer les fetchs
        requestAnimationFrame(async () => {
            await this.renderProductWithFilterSort()
            if(!!evt){
                this.jsonhash = await this.getHashFilters();
                await this.renderFilterCount();
                await this.renderCountRestaurantsLabel()
                await this.renderFilterLink(false)
            }
        })

        // plus besoin de réactiver tous les checkboxes ici
        //remove tous les produits puis ajout du loader et ajouter les prodduit recuperer sur le json collection
    },
    // click sur la paginationation le gerer que si et seulement si y a des filtre et tire
    clickProductPaginate:async function(evt, name, data){
      //  console.log(this.params_filter)

        $('html,body').scrollTop(0);
        evt.preventDefault();
        evt.stopPropagation();
        //relancer la recuperation de la colletion et on change la page
        let linkEl = evt.currentTarget
        this.params_filter["page"]="page="+linkEl.dataset.page

        //save mes nouveau filtre dans le localstorage pour le num page

        this.saveParamsSessionStorage(this.urlBase,this.params_filter)
        await this.renderPaginate()
       
    },
    renderCountRestaurantsLabel: async function(){
       console.log("renderCountRestaurantsLabel",this.count_filters.totals_current)
       let count_restaurant = parseInt(this.count_filters?.totals_current?.count_restaurants) || 0;
       console.log("count_restaurant",count_restaurant)
       let template =  $(".js-count_restaurant_label").attr("data-template");
       let rendu_label = this.plurializeTemplate(template, count_restaurant);
       $(".js-count_restaurant_label").html(rendu_label);
       console.log("renderCountRestaurantsLabel",{template, count_restaurant})
    },
    plurializeTemplate:function(template, count){
        if(!template || template === ''){ return ''; }
        template = template.split("%COUNT%").join(count);
       //changer les parametre de pluralisation %pluriel|singulier% par exemple %s|% ou %aux|al%
        let regex = /%([^%|]*)\|([^%]*)%/g;
        template = template.replace(regex, function(match, p1, p2) {
            return (count > 1 ? p1 : p2);
        });
       return template;
    },
    //changer la pagination en fonction de la collection
    renderPaginateFilterSort(){
        if(!this.templatePagionateTmp){
            $(".js-restaurant_paginate").removeClass("skeleton_paginate");
            this.templatePagionateTmp =  $(".js-restaurant_paginate").html()
        }
        //$(".js-restaurant_paginate").removeClass("hidden");
        if( this.collection['paginate']['pages'] > 1){
            $(".js-restaurant_paginate").removeClass("skeleton_paginate");
            $(".js-restaurant_paginate").html(`<div class="links_paginate">${this.collection['paginate_html']}</div>`)
        }else{
            $(".js-restaurant_paginate").html("")
        }
    },
    renderPaginate: async function(){
        await this.renderProductWithFilterSort()
    },
    
    //------ GENERATEUR DE CARTE PRODUITS EN FNCT DES FILTRES ET TIRES
    renderProductWithFilterSort:async function() {
       // console.log("renderProductWithFilterSort",this.collection_url)
        if(this.collection_url ===""){
            return false
        }
        $('.js-button-sort').removeClass("hidden");
        //si pas de filtre ou de sort ... retour a la normal grace au tmp
        // this.templateTmp

        //TODO revoir si pas de filtre pour rendre les produit avec l ensemble des produits
        if(false && !this.params_filter["filter.p.tag"] && !this.params_filter["sort_by"]){
            $(".js-section_restaurants").html(this.templateSectionTmp)
            $(".js-restaurant_paginate").html(this.templatePagionateTmp)
            return true
        }

        //recuperer la collection avec les filtre et le trie
        await this.getCollection()

        //initialiser la page si utiliser
        //console.log({collection: this.collection, url: window.location.pathname.split("?")})
        window.history.pushState({}, "", this.urlBase)

        //enlever tous les restaurants
        if(!this.templateSectionTmp){
            this.templateSectionTmp =  $(".js-section_restaurants").html()
        }

        if(this.template =="card_restaurants"){
            $(".js-section_restaurants_list").html("")
        }else if(this.template =="card_products"){
            $(".js-section_restaurants").html("")
        }else if(this.template =="card_restaurants_privatisation"){
            $(".js-section_restaurants_list").html("")
        }
        //charger le nouveau pagination.. en fonction du clique
        // celui la sera update faire fonction pour ca
        if(!this.withRestaurants){
            await  this.renderPaginateFilterSort()
            for (let product of this.collection.products) {
                // console.log({product})
                $(".js-section_products_list").append(product.card)
            }
        }else{
            //generer la pagination
            await this.renderPaginateFilterSort()
            //format de la liste est ajouter dans js-section_restaurants
            // class  restaurant_info
            let templateRestaurants = "";
            //difference de template
            if(this.template =="card_restaurants"){
                templateRestaurants = this.template_restaurants_card(templateRestaurants)
            }else if(this.template =="card_products"){
                templateRestaurants = this.template_restaurants_products(templateRestaurants)
            }else if(this.template =="card_restaurants_privatisation"){
                 templateRestaurants = this.template_restaurants_privatisation_card(templateRestaurants)
            }
            

            if(templateRestaurants === ''){
                $('.js-button-sort').addClass("hidden");
                templateRestaurants = `<div class="section_no_result"><p> Malheureusement nous n'avons pas encore d'offres répondant à votre demande. <a href="/" style="text-decoration: underline;font-weight: bold">Revenir à la page d'accueil.</a></p></div>`
            }

            
            if(this.template =="card_restaurants"){
                $(".js-section_restaurants_list").append(templateRestaurants)
            }else if(this.template =="card_products"){
                $(".js-section_restaurants").append(templateRestaurants)
            }else if(this.template =="card_restaurants_privatisation"){
                $(".js-section_restaurants_list").append(templateRestaurants)
            }
        }
    },
    template_restaurants_card:function(){
        console.log("template_restaurants_card")
        let templateRestaurants = "";
 
        for (var restaurant of this.collection.restaurants.datas) {
            let templateRestaurant = $('#js-template_card_restaurant').html();

            templateRestaurant = templateRestaurant.split("%_r.img.src_%").join(restaurant.page_hero_image)

            templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant/"+restaurant.handle)

            templateRestaurant = templateRestaurant.split("%_r.name_%").join(restaurant.name)
            templateRestaurant = templateRestaurant.split("%_r.chef_%").join(restaurant.chef_name||'')
            let adresse = restaurant.address+`<br/>`+restaurant.zip+" "+restaurant.city

            if(restaurant.city.includes("Paris") ){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Paris"
            }
            if(restaurant.city.includes("Marseille")){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Marseille"
            }
            if(restaurant.city.includes("Lyon")){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Lyon"
            }

            templateRestaurant = templateRestaurant.split("%_r.address_%").join(adresse)
            let offres = ""
            for (var key in restaurant.offre_names) {
                let offre_restaurant = restaurant.offre_restaurant[key]
                 let offre_ancre = restaurant.offre_ancres[key]
                if(!restaurant.offre_ancres[key]){
                    offre_ancre = ''
                }
                if(!restaurant.offre_restaurant[key]){
                    offre_restaurant = "restaurant"
                }

                if(restaurant.restaurantlist_handle[key] !== null){
                   // if(restaurant.offre_ancres[key] !== null){
                        offres += `<a href="/pages/${offre_restaurant}/${restaurant.handle}${offre_ancre}" class="restaurant_offre">${restaurant.offre_names[key]}</a>`
                  //  }
                    //offres += `<a href="/pages/liste/${restaurant.restaurantlist_handle[key]}" class="restaurant_offre">${restaurant.offre_names[key]}</a>`
                }else{
                    offres += `<span class="restaurant_offre">${restaurant.offre_names[key]}</span>`
                }
            }
            templateRestaurant = templateRestaurant.split("%_r.offres_%").join(offres)
            
           // console.log({restaurant})
            
            let note_vote = (restaurant.rating_value*0.1).toFixed(1)
            let vote_stars = ""
            if(note_vote !== null){
                vote_stars+=`<div class="product_note"><div class="product_note_txt">${ note_vote}</div>`
                let note_full = Math.floor(note_vote)
                let is_half = note_vote - note_full
                for (let i = 1; i <= note_full; i++) {
                    vote_stars+=`<div class="note_icon note_full"></div>`
                }
                if( is_half >=0.5){
                    vote_stars+=`<div class="note_icon note_half"></div>`
                    note_full = note_full + 1
                }
                let note_empty = 5 - note_full
                for (let i = 1; i <= note_empty; i++) {
                    vote_stars+=`<div class="note_icon note_empty"></div>`
                }
                vote_stars+=`<div class="note_icon note_info noteinfo js_note_info_txt"></div>`
                vote_stars+=`<div class="note_info_txt js_note_info_txt">Moyenne des avis <br/> clients pour ce restaurant.</div>`
                vote_stars+=`</div>`

            }
            templateRestaurant = templateRestaurant.split("%_r.vote_%").join(vote_stars)


            let distinctions_html =''
            if(!!restaurant.michelin_distinction){
                let distinctions = !!restaurant.michelin_distinction && (restaurant.michelin_distinction).includes(",")?restaurant.michelin_distinction.split(","):[restaurant.michelin_distinction]
                //  console.log({name:restaurant.name,michelin_distinction:restaurant.michelin_distinction,distinctions})
                for (var distinction of distinctions) {
                    let current = window.distinction_icons[distinction]||null
                    //  console.log({n:restaurant.name,current,distinction,distinction_icons:window.distinction_icons})
                    if(!!current){
                        let count_image = current.count
                        let icon = current.icon.repeat(count_image)
                        distinctions_html += icon
                    }
                }
            }
            templateRestaurant = templateRestaurant.split("%_r.distinction_icons_%").join(distinctions_html)
            templateRestaurants +=templateRestaurant
        }
        return templateRestaurants
    },
    template_restaurants_privatisation_card:function(){
        console.log("template_restaurants_privatisation_card")
        let templateRestaurants = "";
       // console.log( this.collection.restaurants.datas)
        for (var restaurant of this.collection.restaurants.datas) {
            let templateRestaurant = $('#js-template_card_restaurant').html();
            templateRestaurant = templateRestaurant.split("%_r.img.src_%").join(restaurant.page_hero_image)
            templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant-privatisation/"+restaurant.handle)
            templateRestaurant = templateRestaurant.split("%_r.name_%").join(restaurant.name)
            templateRestaurant = templateRestaurant.split("%_r.chef_%").join(restaurant.chef_name||'')
            let adresse = restaurant.address+`<br/>`+restaurant.zip+" "+restaurant.city

            if(restaurant.city.includes("Paris") ){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Paris"
            }
            if(restaurant.city.includes("Marseille")){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Marseille"
            }
            if(restaurant.city.includes("Lyon")){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Lyon"
            }

            templateRestaurant = templateRestaurant.split("%_r.address_%").join(adresse)
            
            let note_vote = (restaurant.rating_value*0.1).toFixed(1)
            let vote_stars = ""
            if(note_vote !== null){
                vote_stars+=`<div class="product_note"><div class="product_note_txt">${ note_vote}</div>`
                let note_full = Math.floor(note_vote)
                let is_half = note_vote - note_full
                for (let i = 1; i <= note_full; i++) {
                    vote_stars+=`<div class="note_icon note_full"></div>`
                }
                if( is_half >=0.5){
                    vote_stars+=`<div class="note_icon note_half"></div>`
                    note_full = note_full + 1
                }
                let note_empty = 5 - note_full
                for (let i = 1; i <= note_empty; i++) {
                    vote_stars+=`<div class="note_icon note_empty"></div>`
                }
                vote_stars+=`<div class="note_icon note_info noteinfo js_note_info_txt"></div>`
                vote_stars+=`<div class="note_info_txt js_note_info_txt">Moyenne des avis <br/> clients pour ce restaurant.</div>`
                vote_stars+=`</div>`

            }
            templateRestaurant = templateRestaurant.split("%_r.vote_%").join(vote_stars)


            let distinctions_html =''
            if(!!restaurant.michelin_distinction){
                let distinctions = !!restaurant.michelin_distinction && (restaurant.michelin_distinction).includes(",")?restaurant.michelin_distinction.split(","):[restaurant.michelin_distinction]
                //  console.log({name:restaurant.name,michelin_distinction:restaurant.michelin_distinction,distinctions})
                for (var distinction of distinctions) {
                    let current = window.distinction_icons[distinction]||null
                    //  console.log({n:restaurant.name,current,distinction,distinction_icons:window.distinction_icons})
                    if(!!current){
                        let count_image = current.count
                        let icon = current.icon.repeat(count_image)
                        distinctions_html += icon
                    }
                }
            }
            templateRestaurant = templateRestaurant.split("%_r.distinction_icons_%").join(distinctions_html)
            templateRestaurants +=templateRestaurant
        }
        return templateRestaurants
    },
    template_restaurants_products:function(){
        let templateRestaurants = "";
        //generer les restaurants avec les produits
        //recuperer les templacte restaurant solo
        //recuperer le template produit solo
        // boucler avec les informations recuperer avec api pour le generer
        //  console.log({collectiondata:this.collection.restaurants.datas})
        for (var restaurant of this.collection.restaurants.datas) {
            //  console.log({restaurant})
            let templateRestaurant = $('#js-template_section_restaurant').html();
            templateRestaurant = templateRestaurant.split("%_r.name_%").join(restaurant.name)
            
            
            
            templateRestaurant = templateRestaurant.split("%_r.city_%").join(restaurant.city)
         
           // console.log({template:this.template, handle:this.template.handle,restaurant})
            if(this.handle === "les-cours-de-cuisines" || this.type_list === "cc_cours_cuisine_localite"){
                templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant-cours-de-cuisine/"+restaurant.handle+"#cours-de-cuisine")
            }else{
                templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant/"+restaurant.handle+"#cartes_cadeaux")
            }

            //   templateRestaurant = templateRestaurant.split("%_r.city.url_%").join("/pages/villes/"+restaurant.city_handle)
            let distinctions_html =''
            if(!!restaurant.michelin_distinction){
                let distinctions = !!restaurant.michelin_distinction && (restaurant.michelin_distinction).includes(",")?restaurant.michelin_distinction.split(","):[restaurant.michelin_distinction]
                //  console.log({name:restaurant.name,michelin_distinction:restaurant.michelin_distinction,distinctions})
                for (var distinction of distinctions) {
                    let current = window.distinction_icons[distinction]||null
                    //  console.log({n:restaurant.name,current,distinction,distinction_icons:window.distinction_icons})
                    if(!!current){
                        let count_image = current.count
                        let icon = current.icon.repeat(count_image)
                        distinctions_html += icon
                    }
                }
            }

            // console.log({distinctions_html})
            templateRestaurant = templateRestaurant.split("%_r.distinction_icon_%").join(distinctions_html)


            let note_vote=!restaurant.rating_value ? null : (restaurant.rating_value* 0.1).toFixed(1)

            let templateProducts = ''
            for(var product of restaurant.products ){

                let templateProduct =  $('#js-template_card_product').html();
                templateProduct = templateProduct.split("%_p.id_%").join(product.shopify_products_id)
                templateProduct = templateProduct.split("%_v.first.id_%").join(product.variants.data[0].id)
                templateProduct = templateProduct.split("%_p.url_%").join("/products/"+product.shopify_handle)//pas url du produit

                let image = product.images || ''
                if(!!product.images && product.images.includes(",")){
                    image=product.images.split(",")[0]
                }

                templateProduct = templateProduct.split("%_p.img.src_%").join(image)

                let title_product = product.shopify_title
                if(title_product.includes("__")){
                    title_product =  title_product.split("__").join(",")
                }
                if(title_product.includes("||")){
                    title_product =  title_product.split("||").join("&")
                }

                //console.log({lenNameR:title_product.length,name:title_product})
                let title_product_truncate = title_product.length > 60 ? title_product.slice(0, 60) + "..." : title_product;
                templateProduct = templateProduct.split("%_p.title_truncate_%").join(title_product_truncate)
                templateProduct = templateProduct.split("%_p.title_%").join(title_product)

                let vote_stars = ""

                
                if( !!product.shopify_tags && product.shopify_tags.includes("NOTE|")){
                    let tags =product.shopify_tags.includes(", ") ? product.shopify_tags.split(", ") : [product.shopify_tags]
                    note_vote  = (tags.filter((el)=>el.includes("NOTE|"))[0].split("|")[1] * 0.1).toFixed(1)
                }

                if(note_vote !== null){
                    vote_stars+=`<div class="product_note"><div class="product_note_txt">${ note_vote}</div>`
                    let note_full = Math.floor(note_vote)
                    let is_half = note_vote - note_full
                    for (let i = 1; i <= note_full; i++) {
                        vote_stars+=`<div class="note_icon note_full"></div>`
                    }
                    if( is_half >=0.5){
                        vote_stars+=`<div class="note_icon note_half"></div>`
                        note_full = note_full + 1
                    }
                    let note_empty = 5 - note_full
                    for (let i = 1; i <= note_empty; i++) {
                        vote_stars+=`<div class="note_icon note_empty"></div>`
                    }
                    vote_stars+=`<div class="note_icon note_info noteinfo js_note_info_txt"></div>`
                    vote_stars+=`<div class="note_info_txt js_note_info_txt">Moyenne des avis <br/> clients pour ce restaurant.</div>`
                    vote_stars+=`</div>`

                }

                templateProduct = templateProduct.split("%_p.vote_%").join(vote_stars)

                templateProduct = templateProduct.split("%_p.handle_%").join(product.shopify_title)
                templateProduct = templateProduct.split("%_p.type_%").join(product.shopify_product_type)
                templateProduct = templateProduct.split("%_p.tags_%").join(product.shopify_tags)
                templateProduct = templateProduct.split("%_p.vendor_%").join(product.shopify_vendor)

                templateProduct = templateProduct.split("%_r.name_%").join(restaurant.name+" - "+restaurant.city)
                templateProduct = templateProduct.split("%_p.distinction_icons_%").join(distinctions_html)

                let variant_title = ''
                if(!!product.variants.data[0].title){
                    variant_title = product.variants.data[0].title
                }else if(!!product.variants.data[0].option1){
                    variant_title = product.variants.data[0].option1
                }

                let vmulti_price =''
                if(product.variants.data.length > 0 && !variant_title.includes('€') && !variant_title.includes('Default') ){
                    vmulti_price=`<div class="product_price js-product_price" data-pid="${product.shopify_products_id}" >${parseFloat(product.variants.data[0].price).toFixed(2).split(".").join(',')} €</div>`
                }
                templateProduct = templateProduct.split("%_v.multi.price_%").join(vmulti_price)

                let vmulti_select =''
                if(product.variants.data.length > 0){
                    if(product.variants.data.length > 1){
                        vmulti_select+=`<select class="js-select-product">`
                        for (var variant of product.variants.data) {
                            if(!!variant.id){
                                vmulti_select+=`<option  data-vid="${ variant.id}"
                                                 data-pid="${ product.shopify_products_id}"
                                                 data-price="${parseFloat(variant.price)*100}" >${variant.title || variant.option1}</option>`
                            }else{
                                vmulti_select+=`<!-- ERROR pas vid bdd-->`
                            }
                        }
                        vmulti_select+=`</select>`
                    }else{
                        if(!variant_title.includes('€') && !variant_title.includes('Default')  ){
                            vmulti_select=`${variant_title}`
                        }else{
                            vmulti_select=`<div class="product_price js-product_price" data-pid="${product.shopify_products_id}" >${parseFloat(product.variants.data[0].price).toFixed(2).split(".").join(',')} €</div>`
                        }
                    }
                }

                templateProduct = templateProduct.split("%_v.select.price_%").join(vmulti_select)

                if(!!product.variants.data[0].id || this.DEBUGLOG){
                    if(!product.variants.data[0].id){
                        console.error("le produit id= "+product.id+" - le restaurant id= "+restaurant.id+"  - "+restaurant.name+" "+product.shopify_title+" n as pas de variant id dans la bdd ")
                        templateProduct = templateProduct.split("%_ERROR_%").join("error")
                    }else{
                        templateProduct = templateProduct.split("%_ERROR_%").join("")
                    }
                    templateProducts+=templateProduct
                }else{
                    console.error("le produit id= "+product.id+" - le restaurant id= "+restaurant.id+"  - "+restaurant.name+" "+product.shopify_title+" n as pas de variant id dans la bdd ")
                }
            }
            if(templateProducts !== "" ){
                templateRestaurants += templateRestaurant.split("%_r.product_cards_%").join(templateProducts)
            }

        }
        return templateRestaurants
    },
    clearSessionStorage:async function(){
    },
    initFilterTagsBySessionStorage:async function(){
        if(!!this.params_filter['sort_by']){
            let filter_sort = this.params_filter['sort_by'].split("sort_by=").join('')
            $(".js-button-sort").val(filter_sort);
           // if(!this.params_filter['filter.p.tag']){
           //     await this.renderFilterCount();
           //     await this.renderPaginate()
           // }
        }
        if(!!this.params_filter['filter.p.tag'] && this.params_filter['filter.p.tag'].length >0){
            let filter_tags=  this.params_filter['filter.p.tag'].split('filter.p.tag=').join('')
            filter_tags=  filter_tags.split(',')
            for (var filterTag of filter_tags) {
                  $(".js-filter_tag[data-tag='"+filterTag+"']").attr('checked','checked')
            }
           
        }
        
            
        return true
    },
    init:async function () {
        this.DEBUGLOG = false
        this.jsonhash = {}
        console.log("%cSTART CCT.Products-Infini", "background:cyan;color:#333")
        this.bindEvents();
        if(this.handle !==""){
            await this.initFilterTagsBySessionStorage();
            await this.checkboxFilterTags();

            this.jsonhash = await this.getHashFilters();

            await this.renderFilterLink(true)
            await this.renderFilterCount();
            await this.renderCountRestaurantsLabel();
            await this.renderPaginate()
        }
        //relance le checkbox filter si retour avec le bouton precedent du naviguateur
    },

    triggerNoteInfoTxt:async function(evt, name, data){
        const currentElement = evt.currentTarget;
        document.querySelectorAll('.js_note_info_txt').forEach(element => {
            if (element !== currentElement && element !== currentElement.nextElementSibling) {
            element.classList.remove('active');
            }
        });
       
        let noteInfoTxt =evt.currentTarget;
        if (evt.currentTarget.classList.contains("noteinfo")) {
            noteInfoTxt = evt.currentTarget.nextElementSibling;
        } 
        console.log({noteInfoTxt})
        evt.preventDefault();
        evt.stopPropagation();
        if(noteInfoTxt.classList.contains("active")){
            noteInfoTxt.classList.remove("active")
        }else{
            noteInfoTxt.classList.add("active")
        }
    },
    bindEvents:function(){
        $("body")
            .off("change.button_sort").on("change.button_sort", ".js-button-sort",_.bind(this.selectSortBy, this))
            .off("click.product_paginate").on("click.product_paginate", ".js-restaurant_paginate a",_.bind(this.clickProductPaginate, this))
            .off("click.filter_tag").on("click.filter_tag", ".js-filter_tag",_.bind(this.checkboxFilterTags, this))
            .off("click.button-more").on("click.button-more", ".js-button-more",_.bind(this.displayOtherProducts, this))
            .off("change.select-product").on("change.select-product", ".js-select-product",_.bind(this.changeSelectVariants, this))
            .off("click.add_product_cart").on("click.add_product_cart", ".js-add_product",_.bind(this.addproductCart, this))
            .off("click.open_filtre").on("click.open_filtre", ".js-btn-filtre-open",_.bind(this.openFilterMobile, this))
            .off("click.close_filtre").on("click.close_filtre", ".js-btn-filtre-close",_.bind(this.closeFilterMobile, this))
            .off("click.trigger_note_info_txt").on("click.trigger_note_info_txt", ".js_note_info_txt",_.bind(this.triggerNoteInfoTxt, this))

        /*
          $(document)
              .on('TT.filtersValidated', _.bind(this.render, this))
              .on('TT.clearCart',_.debounce( _.bind(this.render, this), TT._.debounceTimeValue))
              .on('TT.removeTTProducts',_.debounce( _.bind(this.removeTTProducts, this), TT._.debounceTimeValue))
              .on('TT.itemCartUpdated', _.bind(this.synchronizeProductsDisplay, this))
              .on('TT.refreshQty', _.bind(this.synchronizeProductsDisplay, this))
              .on('TT.openBtnQty',_.bind(this.openBtnQty,this))
        */
    }
}

console.log("%cRENDER CCT.Products-Infini","background:yellow;color:#333")

